import { render } from "./PieChart.vue?vue&type=template&id=67095d4f"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"
script.render = render

export default script